import AOS from 'aos';
import 'aos/dist/aos.css';
import navigation from './components/navigation'
import skipLinks from './components/skip-links';
import tables from './components/tables';
import dialogs from './components/dialogs';
import tabs from './components/tablist';
import accordions from './components/accordions';

accordions( document.querySelectorAll( 'details' ) );
tabs( document.querySelectorAll( '.tabs' ) );
skipLinks( document.getElementById( 'skip-to-content' ) );
navigation( document.querySelector( '.header__nav' ) )
tables( document.querySelectorAll( 'table' ) );
dialogs( document.querySelectorAll( '[data-open-dialog]' ), document.querySelectorAll( '[data-close-dialog]' ), document.querySelectorAll( '[data-dialog]' ) );

AOS.init( {
  disable: function () {
    return window.innerWidth < 800;
  },
  offset: 120,
  duration: 750,
  easing: 'ease-out-cubic',
  once: true
} );
